/// Base Styles
import typography from "assets/mavric-theme/base/typography";
import borders from "assets/mavric-theme/base/borders";
import colors from "assets/mavric-theme/base/colors";

// Helper Functions
import pxToRem from "assets/mavric-theme/functions/pxToRem";
import rgba from "assets/mavric-theme/functions/rgba";

const { fontWeightBold, size } = typography;
const { borderRadius, borderWidth } = borders;
const { secondary } = colors;

const root = {
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: size.xs,
  fontWeight: fontWeightBold,
  borderRadius: borderRadius.lg,
  padding: `${pxToRem(6.302)} ${pxToRem(16.604)}`,
  lineHeight: 1.4,
  textAlign: "center",
  textTransform: "none",
  userSelect: "none",
  backgroundSize: "150% !important",
  backgroundPositionX: "25% !important",
  transition: "all 150ms ease-in",

  "&:disabled": {
    pointerEvent: "none",
    color: secondary.main,
    border: `1px solid ${secondary.main}`,
  },

  "& .material-icons": {
    fontSize: pxToRem(15),
    marginTop: pxToRem(-2),
  },
};

export default root;
